import React, { Component } from "react";
import { Card } from "../../../components/Card/Card";
import "jqwidgets-scripts/jqwidgets/styles/jqx.base.css";
import "jqwidgets-scripts/jqwidgets/styles/jqx.material-purple.css";
import "jqwidgets-scripts/jqwidgets/styles/jqx.material.css";

import JqxGrid, { jqx } from "jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid";
import { Grid, Col, Button, Row, Modal, Image } from "react-bootstrap";
import Loading from "../../../views/Loading";
import { ExcelReporte } from '../../../components/utils/Excel_produccion.js';
import { dominio } from "../../../routes_backend/routes.jsx";
import Swal from 'sweetalert2';  // Importa SweetAlert2


const myGrid = React.createRef();

export class Liberar_lotes2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sourceGrid: "",
      message: "",
      isLoading: false,
      usrWisap: "",
      userWisapId: "",
      showModal: false,
      showModalconfirm: false,
      responde_server: false,
      messageConfirm: "",
      data_search: [],
    };
  }
  onChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  send_print = () => {
		const { data_search } = this.state;
		let source = [];
		data_search.forEach((element) => {
			let array = [
				element.AbsEntry,
        element.ItemCode,
        element.ItemName,
        element.DistNumber,
        element.MnfSerial,
        element.InDate,
        element.MnfDate,
        element.Notes,
        element.PlannedQty,
        element.Status,
        element.ExpDate,
        element.Resistencia,
        element.Comentario,            
        element.UsrWisap, 
      ];
			source.push(array);
		});
		let name = 'Liberar Lotes';
		let columnas = [
			{ Header: 'AbsEntry' },
			{ Header: 'ItemCode' },
			{ Header: 'ItemName' },
			{ Header: 'DistNumber' },
			{ Header: 'MnfSerial' },
			{ Header: 'InDate' },
			{ Header: 'MnfDate' },
			{ Header: 'Notes' },
			{ Header: 'PlannedQty' },
			{ Header: 'Status' },
			{ Header: 'ExpDate' },
			{ Header: 'Resistencia' },
      { Header: 'Comentario' }
		];

		ExcelReporte(source, columnas, name);
	};

  excelBtnOnClick() {
    myGrid.current.exportdata("xls", "Liberar Lotes");
  }
  componentWillMount() {
    let token = localStorage.getItem("token");
    if (token !== null) {
      let token_Data = JSON.parse(token);
      var user;
      var Iduser;
      token_Data.forEach((element) => {
        user = element.USER_CODE;
        Iduser = element.USERID;
      });
      this.data();
      this.setState({
        usrWisap: user,
        userWisapId: Iduser,
      });
    }
  }


  // Método para obtener los datos desde el backend
  data = () => {
		this.setState({
			message: '',
			isLoading: true
		});
		const response = fetch(`${dominio}/get_LiberarLotes`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
		
			});
		
			response
			.then(async (res) => {
				let data = await res.json();
        let source_Array = [];
				// console.log(data);
				data.forEach((element) => {
					let array = [		



             element.AbsEntry,
             element.ItemCode,
             element.itemName,
             element.DistNumber,
             element.MnfSerial,
             element.InDate,
             element.MnfDate,
             element.Notes,
             element.PlannedQty,
             element.Status,
             element.ExpDate,
             element.Resistencia,
             element.Comentario,            
             element.UsrWisap,            
            "Actualizar",
            "Liberar",



					];
					source_Array.push(array);
				});

        
        let temp_source_grid = {
          localdata: source_Array,
          datafields: [
            { name: "AbsEntry", type: "string", map: "0" },
            { name: "Codigo", type: "string", map: "1" },
            { name: "Descripcion", type: "string", map: "2" },
            { name: "NoLote", type: "int", map: "3" },
            { name: "Operador", type: "string", map: "4" },
            { name: "FechaFabricacion", type: "string", map: "5" },
            { name: "FechaAdmision", type: "string", map: "6" },
            { name: "NoOrden", type: "number", map: "7" },
            { name: "CantidadFabricada", type: "number", map: "8" },
            { name: "Estado", type: "string", map: "9" },
            //----------------- nuevo campo --------------
            { name: "ExpDate", type: "string", map: "10" },
            //-------------- fin nuevo campo --------------
            { name: "Resistencia", type: "string", map: "11" },
            { name: "Comentario", type: "string", map: "12" },
            { name: "UsrWisap", type: "string", map: "13" },
            { name: "Actualizar", type: "string", map: "14" },
            { name: "Liberar", type: "string", map: "15" },
          ],
          data: [],
          datatype: "array",

          };
				this.setState({
          sourceGrid: new jqx.dataAdapter(temp_source_grid),
          message: "",
          data_search: data,
          isLoading: false,
				});
			})
			.catch((error) => {
				console.log(error);
				this.setState({
					isLoading: false,
					message: 'error in the server'
				});
			});
	};






  // data = () => {
  //   let ruta = `${rutas.get_liberar_lotes}`;
  //   console.log(ruta);
  //   fetch(ruta)
  //     .then(async (res) => {
  //       let data = await res.json();
  //       let source_Array = [];
  //       data.forEach((element) => {
  //         let array = [
  //           element.AbsEntry,
  //           element.ItemCode,
  //           element.ItemName,
  //           element.DistNumber,
  //           element.MnfSerial,
  //           element.InDate,
  //           element.MnfDate,
  //           element.Notes,
  //           element.PlannedQty,
  //           element.Status,
  //           element.ExpDate,
  //           element.Resistencia,
  //           element.Comentario,            
  //           element.UsrWisap,            
  //           "Actualizar",
  //           "Liberar",
  //         ];
  //         source_Array.push(array);
  //       });

  //       let temp_source_grid = {
  //         localdata: source_Array,
  //         datafields: [
  //           { name: "AbsEntry", type: "string", map: "0" },
  //           { name: "Codigo", type: "string", map: "1" },
  //           { name: "Descripcion", type: "string", map: "2" },
  //           { name: "NoLote", type: "int", map: "3" },
  //           { name: "Operador", type: "string", map: "4" },
  //           { name: "FechaFabricacion", type: "string", map: "5" },
  //           { name: "FechaAdmision", type: "string", map: "6" },
  //           { name: "NoOrden", type: "number", map: "7" },
  //           { name: "CantidadFabricada", type: "number", map: "8" },
  //           { name: "Estado", type: "string", map: "9" },
  //           //----------------- nuevo campo --------------
  //           { name: "ExpDate", type: "string", map: "10" },
  //           //-------------- fin nuevo campo --------------
  //           { name: "Resistencia", type: "string", map: "11" },
  //           { name: "Comentario", type: "string", map: "12" },
  //           { name: "UsrWisap", type: "string", map: "13" },
  //           { name: "Actualizar", type: "string", map: "14" },
  //           { name: "Liberar", type: "string", map: "15" },
  //         ],
  //         data: [],
  //         datatype: "array",
  //       };
  //       this.setState({
  //         sourceGrid: new jqx.dataAdapter(temp_source_grid),
  //         message: "",
  //         data_search: data,
  //       });
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       this.setState({
  //         message: "error in server",
  //       });
  //     });
  // };
  

  saveBtn = (AbsEntry, Resistencia, Estado, comentario, ExpDate) => {
   


    if ( Resistencia === "" || Resistencia === null || Resistencia === undefined ) {
 
      return this.setState(
        function myFunction() {
          
 
          Swal.fire({
            icon: 'error',
            title: 'Ingrese descripcion de Resistencia!',
            text:  'Campo Resistencia'
          })
          
      });
    }
    if (comentario === "" || comentario === null || comentario === undefined) {

      return this.setState(
        function myFunction() {
          
    
          Swal.fire({
            icon: 'error',
            title: 'Agregue un Comentario',
            text:  'Campo Comentario'
          })
      });
    }
    if (ExpDate === "" || ExpDate === null || ExpDate === undefined) {

      return this.setState(
        function myFunction() {
          

          Swal.fire({
            icon: 'error',
            title: 'Primero debe de actualizar la FECHA DE FINALIZACION y luego liberar',
            text:  'Campo Fecha de Finalizacion'
          })
      });
    }

    this.setState({
			message: '',
			isLoading: true
		});


       var username = "";
       var password = "";
  
       let token = localStorage.getItem("token"); 
       let token_Data = JSON.parse(token); 
       if (token_Data !== null) {
         token_Data.forEach((element) => {
           username = element.usuarioSAP;
           password = element.contraseñaSAP;        
         });
       }
  
       
       if (token_Data === null) {
         this.props.history.push("");
       }
 
    
       var FechaFin = ExpDate;
       var DocEntry = AbsEntry;
    
      let partesFecha = FechaFin.split('/'); 
      let fechaFormateada = `${partesFecha[2]}${partesFecha[1]}${partesFecha[0]}`; 
  
      
   
           const response = fetch(`${dominio}/updateLiberarLote`, {
             method: 'PATCH',
             headers: {
               'Content-Type': 'application/json',
             },
             body: JSON.stringify({ 
              DocEntry,
              fechaFormateada,
              Resistencia,
              Estado,
              comentario,
              username,
              password
             }),
           });
         
           response
             .then((res) => res.json(), )
             .then((data) => {
              console.log(data);
       
               if (data.success) {
  
      
                 Swal.fire({
                  icon: 'success',
                  title: 'Exito',
                  text: 'Lote Actualizado correctamente'
                })
                
                 this.setState({
                  isLoading: false,
                  message: "",
                });
                this.data();
                 return;
                 
                
               } else {
                 console.error('Error en la solicitud:', data[0].message);
      
                 const errorMessage = data[0].message;
                
                 Swal.fire({
                   icon: 'error',
                   title: 'Error al actualizar fecha',
                   text: errorMessage || 'Mensaje de error no disponible'
                 })
      
               }
            
             })
             .catch((error) => {
               console.error('Error en la solicitud:', error);
      
               const errorMessage = error;
                

                 Swal.fire({
                   icon: 'error',
                   title: 'Error en la solicitud',
                   text: errorMessage || 'Mensaje de error no disponible'
                 })
             });
 

  };

  
  saveBtnActualizar = (AbsEntry, ExpDate) => {
    this.setState({
			message: '',
			isLoading: true
		});

       var username = "";
       var password = "";

       let token = localStorage.getItem("token"); 
       let token_Data = JSON.parse(token); 
       if (token_Data !== null) {
         token_Data.forEach((element) => {
           username = element.usuarioSAP;
           password = element.contraseñaSAP;

         });
       }
  
       
       if (token_Data === null) {
         this.props.history.push("");
       }
 

    if ( ExpDate === "" || ExpDate === null || ExpDate === undefined ) {
      return this.setState({
        showModal: true,
        showModalconfirm: true,
        isLoading: false,
        messageConfirm: "Agregue fecha de finalizacion",
        responde_server: false,

      });
    }
   
     var FechaFin = ExpDate;
     var DocEntry = AbsEntry;
  
    let partesFecha = FechaFin.split('/'); 
    let fechaFormateada = `${partesFecha[2]}${partesFecha[1]}${partesFecha[0]}`;

    
 
         const response = fetch(`${dominio}/updateExpDate`, {
           method: 'PATCH',
           headers: {
             'Content-Type': 'application/json',
           },
           body: JSON.stringify({ 
            DocEntry,
            fechaFormateada,
            username,
            password
           }),
         });
       
         response
           .then((res) => res.json(), )
           .then((data) => {
            console.log(data);
     
             if (data.success) {

    
               Swal.fire({
                icon: 'success',
                title: 'Exito',
                text: 'Fecha Actualizada correctamente'
              })
              
               this.setState({
                isLoading: false,
                message: "",
              });
              this.data();
               return;
               
              
             } else {
               console.error('Error en la solicitud:', data[0].message);
    
               const errorMessage = data[0].message;
              
               Swal.fire({
                 icon: 'error',
                 title: 'Error al actualizar fecha',
                 text: errorMessage || 'Mensaje de error no disponible'
               })
    
             }
          
           })
           .catch((error) => {
             console.error('Error en la solicitud:', error);
    
             const errorMessage = error;
              
               Swal.fire({
                 icon: 'error',
                 title: 'Error en la solicitud',
                 text: errorMessage || 'Mensaje de error no disponible'
               })
           });
 
    
  };
  
  handleCloseEnable = () => {
    this.setState({ showModalconfirm: false });
    
  };
  render() {
    const temp_res = Object.entries(this.state.sourceGrid).length === 0; // true
    const columns = [
      // { text: "AbsEntry", datafield: "AbsEntry", width: "4%", editable: false },
      { text: "Codigo", datafield: "Codigo", width: "7%", editable: false, pinned: true },
      { text: "Descripcion", datafield: "Descripcion", width: "21%", editable: false, pinned: true },
      { text: "Lote", datafield: "NoLote", width: "9%", editable: false, pinned: true },
      { text: "Operador", datafield: "Operador", width: "5%", editable: false, },
      { text: "F. Fabricacion", datafield: "FechaFabricacion", editable: false, width: "7%", },
      { text: "F. Admision", datafield: "FechaAdmision", editable: false, width: "7%", },
      { text: "No Orden", datafield: "NoOrden", editable: false, align: "rigth", cellsalign: "center", columntype: "numberinput", cellsformat: "N", width: "6%", },
      { text: "Cant. Fabricada", datafield: "CantidadFabricada", width: "6%", editable: false, align: "rigth", cellsalign: "center", columntype: "numberinput", cellsformat: "N", },
      { text: "Estado", datafield: "Estado", width: "5%", editable: false, },
      { text: "F. Finalizacion", datafield: "ExpDate", width: "7%", /* filtertype: 'date',*/ cellsalign: 'right', /*cellsformat: 'dd/MM/yyyy'*/
        
    
      },
      { text: "Resistencia", datafield: "Resistencia", width: "9%" },
      { text: "Comentario", datafield: "Comentario", width: "9%" },

      { text: "Actualizar", datafield: "Actualizar", width: "5%", columntype: "button", cellclassname: "special",
          buttonclick: (row)=> {
            
            const dataRecord = myGrid.current.getrowdata(row);
            
            var AbsEntry, ExpDate;

            AbsEntry = dataRecord.AbsEntry;
            ExpDate = dataRecord.ExpDate;          // console.log(ExpDate);         

            

             this.saveBtnActualizar( 
              AbsEntry, 
              ExpDate
            );           

          },
      },
      { text: "Liberar", datafield: "Liberar", width: "5%", columntype: "button" , 
          buttonclick: (row: number): void => {
            const dataRecord = myGrid.current.getrowdata(row);
            var AbsEntry, Resistencia, Estado, comentario, ExpDate;
            AbsEntry = dataRecord.AbsEntry;
            Resistencia = dataRecord.Resistencia;
            Estado = "bdsStatus_Released";
            comentario = dataRecord.Comentario;
            ExpDate = dataRecord.ExpDate;

          
            
            

            this.saveBtn( 
              AbsEntry, 
              Resistencia !== undefined || Resistencia !== null ? Resistencia : "",
              Estado,
              comentario !== undefined || comentario !== null || comentario !== "" || comentario !== "undefined" ? comentario : "NULL",
              ExpDate !== undefined || ExpDate !== null || ExpDate !== "" || ExpDate !== "undefined" ? ExpDate : "NULL"
            );
            
          },
      },
      
    ];
    return (
      <div
        className="content"
        style={{ textAlign: "center", alignItems: "center" }}
      >
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Liberar Lotes"
                category=""
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div className="content">
                    <div>
                      <div>
                        <p>{this.state.message}</p>
                        {temp_res === false ? (
                          <div>
                            <JqxGrid
                              ref={myGrid}
                              // groups={["FechaFabricacion"]}
                              theme={"material"}
                              width={"100%"}
                              height={"600px"}
                              groupable={true}
                              columns={columns}
                              source={this.state.sourceGrid}
                              //----------
                              columnsresize={true}
                              //----------
                              //groups={[ 'Descripcion' ]}
                              //autoheight={true}
                              editable={true}
                              sortable={true}
            filterable={true}
            showfilterrow={true}
                              
                            />
                          </div>
                        ) : (
                          ""
                        )}
															<br />
															{/* {!_.isEmpty(this.state.sourceGrid4) ? ( */}
																<center>
																	<br />
																	<div>
																		<br />
																		<br />
																		<Button
																			/* onClick={this.excelBtnOnClick} */ onClick={
																				this.send_print
																			}
																			bsStyle="primary"
																			active
																		>
																			<i className="pe-7s-print" />
																			Download Excel.
																		</Button>
																	</div>
																	<br />
																	<br />
																</center>
															{/* ) : (
																''
															)} */}
                        {this.state.isLoading === false
                          ? this.state.showModal && (
                            <Modal
                              show={this.state.showModalconfirm}
                              onHide={this.handleCloseEnable}
                              bsSize="sm"
                            >
                              <Modal.Header closeButton />
                              <Modal.Body>
                                <div>
                                  <center>
                                    <strong>
                                      {this.state.responde_server === true
                                        ? "Lote actualizado exitosamente"
                                        : "¡Ha ocurido un error!"}
                                    </strong>
                                  </center>
                                  <br />
                                  <center>
                                    <p style={style.message}>
                                      {this.state.message}
                                    </p>
                                    <div>{this.state.messageConfirm}</div>
                                  </center>
                                  <br />
                                  <center>
                                    {this.state.responde_server === true ? (
                                      <Image
                                        src={
                                          "https://us.123rf.com/450wm/photoart23d/photoart23d1902/photoart23d190201464/117662421-marcas-de-verificaci%C3%B3n-degradado-verde-icono-de-marca-dentro-del-c%C3%ADrculo-ilustraci%C3%B3n-vectorial.jpg?ver=6"
                                        }
                                        width={"25%"}
                                        height={"auto"}
                                      />
                                    ) : (
                                      <Image
                                        src={
                                          "https://us.123rf.com/450wm/arcady31/arcady311108/arcady31110800003/10101127-vector-attention-warning-sign.jpg?ver=6"
                                        }
                                        width={"30%"}
                                        height={"auto"}
                                      />
                                    )}
                                  </center>
                                </div>
                              </Modal.Body>
                              <Modal.Footer>
                                <div style={{ float: "left" }}>
                                  <Button
                                    onClick={this.handleCloseEnable}
                                    bsStyle="info"
                                    active
                                  >
                                    Cerrar!
                                  </Button>
                                </div>
                              </Modal.Footer>
                            </Modal>
                          )
                          : null}
                      </div>
                    </div>
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
        {this.state.isLoading && <Loading />}
      </div>
    );
  }
}

export default Liberar_lotes2;
const style = {
  message: {
    fontWeight: "bold",
    fontSize: "12px",
    height: "10px",
    color: "red",
  },
  alert: {
    position: "relative",
    padding: "1rem 1rem",
    border: "1px solid transparent",
  }
};
